import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFlag, faSearch, faUndo, faSortAsc, faSortDesc, faSort} from "@fortawesome/free-solid-svg-icons";
import { faCalendar, faCalendarCheck, faCalendarDays, faCalendarXmark, faEnvelope, faFilePdf, faNoteSticky, faWindowClose } from "@fortawesome/free-regular-svg-icons";
import { Tooltip } from "react-tooltip"
import { GetAccountName } from './Account';
import { enforceRetention } from '../App';
import { GetDeviceSNWithTag } from './Device';
import { Notes } from './Note';
import { Players } from './Player';
import { ReportStatus } from './Report';
import { CaseReportWithAttempts } from './ReportWithAttempts';
import { ArchiveMoveMenu } from './Archive';
import { CurrentTimeFormat, CurrentTimeZoneName, TimeStringForTimeZone } from './Setting';
import { UserNotifyModal, GetUserFullname } from "./User"
import { VideoTableInstruction } from './Video';
import { toUrlSafeBase64, fromUrlSafeBase64 } from './utils';
import { useTeamAndUser, useDevices, useReports } from "../hook/DataProvider"
import ReactJson from '@microlink/react-json-view';
import useAuth from '../hook/useAuth';
import useDeepVinApi from '../hook/useDeepvinApi';
import { customSearchInput, MultiValueRemove, DropdownIndicator, IndicatorSeparator } from './utils';
import Select from 'react-select'
import {LabelToggleRow} from './Label';
import { ExportCaseReportButton } from './Export';

export const Case = () => {
  const { auth } = useAuth()
  const api = useDeepVinApi()
  const {id} = useParams() // Video CaseNumber
  const origCN = fromUrlSafeBase64(id)
  const [currentCN, setCurrentCN] = useState(origCN)
  const [editedCN, setEditedCN] = useState(origCN)

  const [videos, setVideos] = useState([])

  const [activeVid, setActiveVid] = useState();
  const [playingStatus, setCasePlayingStatus] = useState(true);

  const [showNotifyModal, setShowNotifyModal] = useState(false)
  const [teams, users] = useTeamAndUser()
  const [editCN, setEditCN] = useState(false)
  const [hasReports, setHasReports] = useState(false)
  const [playerRefs, setPlayerRefs] = useState(null)
  const [flag, setFlag] = useState(false)
  const refresh = () => setFlag(!flag)

  useEffect(() => {
    const encodedId = toUrlSafeBase64(currentCN)
    // console.log("encodedId: ", encodedId)
    api.get(`/api/case/${encodedId}`)
    .then(({data}) => {
      setVideos(data?.Videos)
      if (data?.Videos?.length > 0)
        setActiveVid(data.Videos[0].ID)
      setHasReports(data?.Reports?.length > 0)   
    })
    .catch(error => console.error("Error: ", error))
  }, [currentCN, flag])
    
    const handleCancelEditCN = (e) => {
      setEditedCN(currentCN)
      setEditCN(false)
    }
    
    const handleCNEditClick = async(e) => {
      if (editCN){ // save CN change
        // Trim the input value to remove leading and trailing white spaces
        const trimmedInput = editedCN.trim();
        // Check if the trimmed input is empty
        if (trimmedInput === "") {
            setEditedCN(currentCN)
            alert("The input cannot be empty or just white spaces.")
            return
        }
        // if both oldCN and newCN have reports associated, we want to give a warning,
        // the oldCN reports' case number will not changed, and the videos will be associated with newCN reports
        if (hasReports){
          try {
            const encodedId = toUrlSafeBase64(trimmedInput)
            const response = await api.get(`/api/case/${encodedId}`)
            console.log(response.data)
            if (response?.data?.Reports?.length > 0){
              if (!window.confirm(`Both original Case ${currentCN} and input Case ${trimmedInput} have associated reports. The video(s) will only be associated with Case ${trimmedInput} after change. \nProceed?`)) {
                return
              }
            }
          } catch (error) {
              console.error("Error checking new case number "+trimmedInput+", ", error)
          }
        }

        const encodedId = toUrlSafeBase64(currentCN)
        api.post(`/api/case/${encodedId}`, {NewCaseNum: trimmedInput})
        .then(({data}) => {
          setVideos([])
          setCurrentCN(trimmedInput)
          setEditedCN(trimmedInput)
        })
        .catch(error => console.error("API error: ", error))
      }

      setEditCN(!editCN)
    }

    const handleCaseUnassign = (id) =>{
      // console.log("###### unassign video id:", id)
      if (videos?.length <= 1){
        alert("Can't remove the last video from current Case.")
        return
      }
  
      if (id && window.confirm(`Are you sure you want to remove this video from current Case?\n\nTo delete the video completely, use the \"Teams & Videos\" table.`)){
        const encodedId = toUrlSafeBase64(currentCN)
        api.post(`/api/case/${encodedId}/unassign`, {VideoID: id})
        .then(({data}) => {
          //console.log("Remaining videos:", data)
          // The videos need to be cleared. Otherwise, the playerRefs seem to
          // be lingering around, and the players won't match videos
          setVideos([])
          refresh()
        })
        .catch(error => { 
          alert("Failed to remove video from current Case.")
          console.error("Error: ", error) } )      
      }
    }
  
  if (videos && activeVid)
  return (
    <>
    <div class="row" style={{ minWidth: '800px' }}>
      <div class="col-6">
        <div class="row">
          <div class="col-lg-8 col-sm-8">
            <div class="input-group align-items-center">
              <span class="input-group-text border-0 fw-bold" id="basic-cn">Case # </span>&nbsp;
              {editCN 
                ? <input type="text" class="form-control" placeholder="CaseNumber" aria-label="casenumber" value={editedCN} onChange={e=>setEditedCN(e.target.value)}/>
                :  currentCN
              }
            </div>
            
            {/* <h4>Case #
              {editCN
              ? <input type="text" class="form-control" value={editedCN} placeholder="CaseNumber" aria-label="casenumber" onChange={e=>setEditedCN(e.target.value)}/>
              : currentCN
              }
            </h4> */}
          </div>
          <div class="col-lg-4 col-sm-4">
            <div className="d-flex justify-content-end">
            {editCN
            ? <div class="btn-group align-items-center" role="group">
                <button class="btn btn-success" onClick={handleCNEditClick}>Save</button>
                <button class="btn btn-warning" onClick={handleCancelEditCN}>Cancel</button>
            </div>
            : <div class="btn-group align-items-center" role="group">
                <button class="btn btn-outline-secondary" onClick={handleCNEditClick}>Edit</button>
                {(auth?.IsRoot || auth?.IsAdmin) && <button class="btn btn-outline-secondary" onClick={()=>setShowNotifyModal(true)}>Notify</button>}
            </div>
            }
            </div>
          </div>
        </div>
        {<Players videos={videos} setPlayerRefs={setPlayerRefs} setActiveVid={setActiveVid}  
        playingStatus={playingStatus} setCasePlayingStatus={setCasePlayingStatus} caseUnassigned={handleCaseUnassign}/>}
      </div>
      <div class="col-6">
        <CaseReview caseNumber={currentCN} video={videos.find(v => v.ID === activeVid)} playerRef={playerRefs?.current[activeVid]} setCasePlayingStatus={setCasePlayingStatus}/>
      </div>
    </div>
    { users && <UserNotifyModal show={showNotifyModal} setShow={setShowNotifyModal} caseNum={currentCN} />}
    {/* <ReactJson src={videos} /> */}
    </>
  )
}

export const CaseReview = ({caseNumber, video, playerRef, setCasePlayingStatus}) => {
  return (
    <>
    <div class="accordion" id="reportAndNotes">

      <div class="accordion-item">
        <h2 class="accordion-header" id="headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
          <p className="accordion-right-align"><strong>Timestamp Notes</strong></p>
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#reportAndNotes">
          <div class="accordion-body">
            <div>
              {video && <Notes video={video} playerRef={playerRef} setCasePlayingStatus={setCasePlayingStatus}/>}
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header custom-accordion-button " id="headingNewCard">
          <button class="accordion-button d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNewCard" aria-expanded="true" aria-controls="collapseNewCard">
            <p className="accordion-right-align"><strong>Airway Report Card </strong></p>               
          </button>
        </h2>
        <div id="collapseNewCard" class="accordion-collapse collapse show" aria-labelledby="headingNewCard" data-bs-parent="#reportAndNotes">
          <div class="accordion-body"> 
            <div class="align-items-top">
                {video && <CaseReportWithAttempts caseNumber={caseNumber} archiveID={video.ArchiveID} />}
            </div>
          </div>
        </div>
      </div>
      {/* <div class="accordion-item">
        <h2 class="accordion-header custom-accordion-button " id="headingCard">
          <button class="accordion-button d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCard" aria-expanded="true" aria-controls="collapseCard">
            <p className="accordion-right-align"><strong>Airway Report Card</strong></p>               
          </button>
        </h2>
        <div id="collapseCard" class="accordion-collapse collapse" aria-labelledby="headingCard" data-bs-parent="#reportAndNotes">
          <div class="accordion-body"> 
            <div class="align-items-top">
                {video && <AirwayReport caseNumber={video.CaseNumber} />}
            </div>
          </div>
        </div>
      </div> */}
    </div>
        {/* <hr /> 
        <div class="col-6">
          <button type="button" class="btn btn-danger me-2" onClick={(e) => handleUpdate(e, true)}>Submit</button>
        </div> */}
    {/* <ReactJson src={{url, title, video}} /> */}
    </>
  )
}

const _columns = [
  { key: 'case_number', label: 'Case #', jfield:'CaseNumber', sortable: true, searchable: true },
  { key: 'create_date', label: 'Video Time', jfield:'CreateDate', sortable: true, searchable: true },
  { key: 'created_at', label: 'Upload Time', jfield:'CreatedAt', sortable: true, searchable: true },
  // { key: 'file_name', label: 'File Name', jfield:'FileName', sortable: true, searchable: false  },
  { key: 'source', label: 'Device | Tag', jfield:'Source', sortable: true, searchable: true },
  { key: 'provider_id', label: 'Assigned To', jfield:'ProviderID', sortable: true, searchable: true },
  // { key: 'to_keep', label: 'Retention', jfield:'ToKeep', sortable: true, searchable: false },
  // { key: 'team_id', label: 'Team', jfield:'TeamID', sortable: true, searchable: false },
  // { key: 'action', label: 'Action', jfield:'NA', sortable: false, searchable: false },
  // Add more columns as needed
]

export const CaseArchiveTable = ({ archives, archiveID, refresh}) => {
  const api = useDeepVinApi()
  const [teams, users] = useTeamAndUser()
  const devices = useDevices()
  const reports = useReports()
  // const archives = useArchives()

  const itemProps = {
    teams: teams,
    users: users,
    devices: devices,
    reports: reports,
    archives: archives,
    archive: archiveID===undefined ? undefined : archives?.find(a=>a.Archive.ID===archiveID),
  }

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(0)
  const [sortBy, setSortBy] = useState('created_at')
  const [order, setOrder] = useState('desc')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [searchData, setSearchData] = useState([])
  const [searchResults, setSearchResults] = useState([])
  const [searchBoxIDs, setSearchBoxIDs] = useState({})

  const [hoveredColumn, setHoveredColumn] = useState(null)
  const handleMouseOver = (column) => {
    setHoveredColumn(column);
  }
  const handleMouseOut = () => {
    setHoveredColumn(null);
  }

  const [flag, setFlag] = useState(false)
  const selfrefresh = () => {
    setFlag(!flag)
    // refresh()
  }

  const { auth, setAuth } = useAuth()
  const useRetention = enforceRetention && auth?.IsRoot

  const [retentionDays, setRetentionDays] = useState()
  useEffect(() => {
    if (!useRetention) return

    api.get("/api/account/policy")
    .then(({data}) => {
      setRetentionDays(data.RetentionDays)
    })
    .catch(error => {
        setRetentionDays(null)
        console.error("API error: ", error)
    })
  }, [])

  let visitedCases = {}; // This is our [string, bool] map
  const [checkedState, setCheckedState] = useState({})

  useEffect(() => {

    if (archiveID === undefined)
        return
    // console.log("###### apiUrl: ", apiUrl)
    api.get(`/api/archive/${archiveID}/video`, {
      params: {
        page,
        limit,
        sortBy,
        order,
        startDate,
        endDate,
      }
    })
    .then(({data}) => {
        // data is 
        // model.PaginationPageResult{
        //   PageItems:   items,
        //   CurrentPage: pagination.Page,
        //   PageLimit:   pagination.Limit,
        //   TotalPage:   totPages,
        //   TotalItem:   totItems,
        // }
        if (data?.PageItems){
          let caseData = data.PageItems.filter(v => v.CaseNumber !== "")
          let arrCase = caseData.map(c=>c.CaseNumber)
          const uniqueCount = new Set(arrCase).size

          let uniqeItemAndIndices = {}
          caseData.forEach((item, index) => {
            if (uniqeItemAndIndices[item.CaseNumber]){
              let cur = uniqeItemAndIndices[item.CaseNumber]
              // console.log("cur: ", cur)
              const currentMoment = moment.tz(cur.item.CreatedAt, "America/New_York")
              const itemMoment = moment.tz(item.CreatedAt, "America/New_York")
              
              if ( itemMoment.isBefore(currentMoment)){ // use older item
                uniqeItemAndIndices[item.CaseNumber] = {item, index}
              }
            } else{
              uniqeItemAndIndices[item.CaseNumber] = {item, index}
            }
          })

          const orderedIndices = Object.values(uniqeItemAndIndices).map(obj=>obj.index)
          
          let uniqueItems = []
          caseData.forEach((item, index) => {
            if (orderedIndices.includes(index)){
              uniqueItems.push(item)
            }
          })

          setSearchData(uniqueItems)
          setSearchResults(uniqueItems)
          let numChecks = Object.keys(checkedState).length
          // console.log("unique case num, checks num", uniqueCount, numChecks)
          if (numChecks === 0 || uniqueCount !== numChecks){
            let checked = {}
            uniqueItems.forEach((item) => checked[item.CaseNumber]=false)
            setCheckedState(checked)
          }
        }
        
        visitedCases = {}
        setSearchBoxIDs({})
    })
    .catch(error => { 
        console.error("Error: ", error) 
        //toast.error(error.response.data.error)
    })
  }, [flag, archiveID, sortBy, order, startDate, endDate])

    const handleSort = (column) => {
    const sortOrder = sortBy === column && order === 'asc' ? 'desc' : 'asc'
    setSortBy(column)
    // console.log("### Sort by: ", column)
    setOrder(sortOrder)
  }

  const handleDateChange = (setter) => (event) => {
    setter(event.target.value)
  }

  const caseVisited = (cn) => {
    if (cn !== ""){
      if (visitedCases[cn]) return true

      visitedCases[cn] = true
      return false
    }else { // skip empty case_numbers
      return true
    }
  }

  const [isSearching, setIsSearching] = useState(false);
  const toggleSearch = (e) => {
    setSearchBoxIDs({})
    setIsSearching(!isSearching) // Toggle the state
    setSelectedLabels([]) // reset labels
  }

  const resetSearch = (e) => {   
    Object.keys(searchBoxIDs).forEach(id => {
      const inputElement = document.getElementById(id)
      console.log(`inputElement: ${inputElement}, id: ${id}`)
      if (inputElement) {
          inputElement.value = '' // Clear the input value directly
      }
    })

    setSearchBoxIDs({})
    setFlag(!flag) // re-render
  }

  //const hasTeams = itemProps?.teams !== undefined;
  const hasUsers = itemProps?.users !== undefined;
  const hasDevices = itemProps?.devices !== undefined;
  const hasAccts = itemProps?.accounts !== undefined;
  const getSpecialFieldVal =(item, f) => {
    if (f === "CreatedAt" || f==="CreateDate" 
      || f === "InvoiceDate" || f === "DueDate" || f === "StartDate" // for Invoices
    ) // Time format is mm/dd/yyyy hh:min am/pm
     return TimeStringForTimeZone(auth, item[f])
    else if(f === "Source" && hasDevices) {// The text format "<Source> | <Tag>"
      return  GetDeviceSNWithTag (item.Source, itemProps.devices)
    }
    else if(f === "ProviderID" && hasUsers) {// The text format for the user "<FirstName> <LastName>"
      return GetUserFullname (item.ProviderID, itemProps.users)
    }
    else if((f === "CustomerID" || f === "DistributorID") && hasAccts) {
      return f === "CustomerID" 
              ? GetAccountName (item.CustomerID, itemProps.accounts)
              : GetAccountName (item.DistributorID, itemProps.accounts)
    }
    else
      return item[f]
  }

  const isItemFound = (item, field, val) =>{

    for (const [f, v] of Object.entries(searchBoxIDs)){
      // console.log(`Key: ${f}, Value: ${v}, itemFieldVal: ${item[f]}`)
      let value = f === field ? val : v
      if (getSpecialFieldVal(item, f).toLowerCase().includes(value.toLowerCase()) !== true)
        return false
    }

    return Object.keys(searchBoxIDs).includes(field) ? true : 
      getSpecialFieldVal(item, field).toLowerCase().includes(val.toLowerCase())
  }

  const handleSearchChange = (field, val) =>{
    console.log(`ChangingKey: ${field}, Value: ${val}`)
    
    setSearchResults(searchData.filter(item => isItemFound(item, field, val)))
    setSearchBoxIDs({...searchBoxIDs, [field]:val});
  }

  // Handler for changing the header checkbox
  const handleHeaderCheckboxChange = (event) => {
    let checked = {...checkedState}
    let val = event.target.checked
    searchResults.forEach((item) => { // only change the check state for searchResults
      checked[item.CaseNumber] = val
    })
    setCheckedState(checked);
  }

  // Handler for changing individual row checkboxes
  const handleRowCheckboxChange = (cn) => {
    let val = !checkedState[cn]
    setCheckedState({...checkedState, [cn]:val})
  }

  const handleArchivingSelected = (selArchive) => {
    let caseNums = []
    searchData.forEach((item) => { // only change the check state for searchResults
      if (checkedState[item.CaseNumber]) caseNums.push(item.CaseNumber)
    })
    
    if (caseNums.length === 0) return
    
    if (selArchive === undefined || selArchive === archiveID) return

    api.post(`/api/archive/${selArchive}/case`, caseNums)
      .then(({}) => {
        toast.success("Cases are moved successfully")
      })
      .catch((error) => {
        toast.error(error.response?.data?.error)
      })
    // setSelArchive(undefined)
    setCheckedState({})
    selfrefresh()
    refresh()
  }

  const [selectedLabels, setSelectedLabels] = useState([]);
  const [caseLabels, setCaseLabels] = useState([])
  useEffect(() => {
      api.get('/api/label/')
      .then(response => setCaseLabels(response.data))
      .catch(error => console.error("Error fetching case labels: ", error));
  }, [])

  useEffect(() => {
    // Filter cases based on selected labels
    
    if (selectedLabels.length === 0) {
      setSearchResults(searchData);
    } else {
      const keys = Object.keys(caseLabelMap);
      
      let filteredCases = [];
      for (const item of searchData) {
        if (!keys.includes(item.CaseNumber)) {
          continue; // skip cases with no labels
        }
        for (const label of selectedLabels) {
          if (caseLabelMap[item.CaseNumber].includes(label)) {
            // If the case has the label, add it to the filtered cases
            filteredCases.push(item);
            break; // No need to check other labels for this case
          }
        }
      }
      setSearchResults(filteredCases);
    }
  }, [selectedLabels])

  const [labeledCases, setLabeledCases] = useState([])
  const [cases, setCases] = useState([])

  useEffect(() => {
    api.get('/api/label/cases')
    .then(response => {
      setLabeledCases(response.data.Labels)
      setCases(response.data.Cases)})
    .catch(error => console.error("Error fetching labeled cases: ", error));
  }, [])

  function buildCaseLabelMap(cases, caseLabels) {
    // First, make a quick lookup: CaseID → CaseNumber
    const idToNumber = {};
    for (const c of cases) {
      idToNumber[c.ID] = c.CaseNumber;
    }

    // Now build CaseNumber → array of label names
    const caseNumberToLabels = {};
    for (const label of caseLabels) {
      const caseNumber = idToNumber[label.CaseID];
      if (!caseNumber) continue; // skip if label refers to non-existent case

      if (!caseNumberToLabels[caseNumber]) {
        caseNumberToLabels[caseNumber] = [];
      }
      caseNumberToLabels[caseNumber].push(label.Name);
    }

    return caseNumberToLabels;
  }

  const caseLabelMap = buildCaseLabelMap(cases, labeledCases);
  const getCaseLabels = (caseNumber) => {
    return caseLabelMap[caseNumber] || [];
  }

  let columns = [..._columns]
  if (useRetention) columns.push({ key: 'to_keep', label: 'Retention', jfield:'ToKeep', sortable: false, searchable: false})

  if (searchData)
  return (
    <>
      <div class="row mt-2 mb-2">
        <LabelToggleRow
          options={caseLabels?.map(label => label.Name) || []}
          selectedLabels={selectedLabels}
          setSelectedLabels={setSelectedLabels}
          isDisabled={isSearching}
        />
      </div>
      <div class="row mx-1">
      <button id="searchButton" class="btn btn-sm btn-outline-primary mt-2 col-2" onClick={toggleSearch}>
      <FontAwesomeIcon icon={isSearching ? faWindowClose : faSearch } /><span class="fw-bold"> {isSearching ? "Close Search" : "Search by ..."}</span></button>
      {isSearching && <button id="resetSearchButton" class="btn btn-sm btn-outline-primary mt-2 col-2 mx-1" onClick={resetSearch}>
          <FontAwesomeIcon icon={faUndo } /><span class="fw-bold"> Reset Search</span></button>}
      </div>
      {isSearching && <div class="row mt-2 mb-2">
        
        {_columns.map((column) => column.searchable && <div class="form-floating col-2">
          <input data-cy={column.key} type="text" class="form-control" id={column.jfield} placeholder={column.label} 
          onChange={(e) => handleSearchChange(column.jfield, e.target.value)}/>
          <label for={column.jfield} class="mx-2"><FontAwesomeIcon size='sm' icon={faSearch}/>&nbsp;{column.label}</label>
        </div>
        )}
      </div>}

      <div class="my-3">
        <label class="fw-bold">
          Added From:&nbsp;
          <input class="me-3" type="date" value={startDate} onChange={handleDateChange(setStartDate)} />
        </label>
        <label  class="fw-bold">
          To:&nbsp;
          <input class="me-3" type="date" value={endDate} onChange={handleDateChange(setEndDate)} />
        </label>
      </div> 

      <table className="table table-hover">
        <thead>
          <tr>
            {auth.IsRoot && <th class="text-center me-0">
              <div class="input-group input-group-sm">
              <input class="me-2"
                type="checkbox"
                onChange={handleHeaderCheckboxChange}
                checked={Object.keys(checkedState).length>0 && Object.values(checkedState).every(v => v === true)}
              />
              {Object.values(checkedState).some(v => v === true) && 
              <ArchiveMoveMenu archives={archives.filter(a=>a.Archive.ID!==archiveID)} setArcId={handleArchivingSelected} />}
              </div>
            </th>}
            {columns.map((column) => column.sortable && <th key={column.key} style={{ backgroundColor: sortBy===column.key?'lightgrey':'' }}
                    onMouseOver={() => handleMouseOver(column.key)}
                    onMouseOut={handleMouseOut}
                    onClick={() => handleSort(column.key)}>
                    {column.label} 
                    {sortBy===column.key ? <FontAwesomeIcon icon={order==='asc'? faSortAsc : faSortDesc}/>
                      : hoveredColumn === column.key && <FontAwesomeIcon icon={faSort} />}</th> 
            )}
            {auth?.IsRoot && <th><FontAwesomeIcon id='export_col' icon={faFilePdf} /> </th>}
            {auth?.IsRoot && <th><FontAwesomeIcon id='notify_col' icon={faEnvelope} /> </th>}
            {useRetention && <th><FontAwesomeIcon id='retention_col' icon={faCalendarDays} /></th>}
          </tr>
        </thead>
        <tbody>
          {searchResults?.map((item) => !caseVisited(item.CaseNumber) && 
          <CaseArchiveTab key={item.ID} item={item} labels={getCaseLabels(item.CaseNumber)} refresh={selfrefresh} retentionDays={retentionDays} numColumns={columns.length} {...itemProps}
          checked={checkedState[item.CaseNumber]} handleRowCheckboxChange={handleRowCheckboxChange}/>)}
          
        </tbody>
      </table>

      <VideoTableInstruction />
      {useRetention && <ArchiveTableInstruction />}
      <Tooltip anchorSelect="#retention_col" place="top">Retention Status</Tooltip>
      <Tooltip anchorSelect="#notify_col" place="top">Notify</Tooltip>
      <Tooltip anchorSelect="#export_col" place="top">Export Report as PDF<br />Use png/jpeg for agency logo,<br />svg not supported for export</Tooltip>
      {/* <ReactJson src={searchBoxIDs} /> */}
      {/* <ReactJson src={searchData} /> */}
    </>
  )
}

export const ArchiveTableInstruction = () => {
  return (
    <div class="mt-3">
      <span>
        <FontAwesomeIcon icon={faCalendarXmark} size="sm" color="red"/>&nbsp;&nbsp;Retention expired&nbsp;&nbsp; 
        <FontAwesomeIcon icon={faCalendarCheck} size="sm" color="green"/>&nbsp;&nbsp;Keep after retention&nbsp;&nbsp;
        <FontAwesomeIcon icon={faCalendar} size="sm" color="red"/>&nbsp;&nbsp;Less than 15 days&nbsp;&nbsp;
        <FontAwesomeIcon icon={faCalendar} size="sm" color="orange"/>&nbsp;&nbsp;Less than 30 days&nbsp;&nbsp;
        <FontAwesomeIcon icon={faCalendar} size="sm" color="black"/>&nbsp;&nbsp;More than 30 days
      </span>
    </div>
  )
}

export const CaseArchiveTab = ({item, labels, refresh, teams, users, devices, reports, retentionDays, numColumns, archives, archive,
  checked, handleRowCheckboxChange}) => {
  const [video, setVideo] = useState(item)
  const [createTZTime, setCreateTZTime] = useState()
  const { auth } = useAuth()
  const api = useDeepVinApi()
  const [showNotifyModal, setShowNotifyModal] = useState(false)

  useEffect(() => {
    setVideo(item)//{...data, ["CaseNumber"]: item.CaseNumber, ["TeamID"]: item.TeamID, ["ProviderID"]: item.ProviderID})
    setCreateDateWithZone(item.CreateDate)
  }, [item])

  const switchRetention = () =>{
    let statusMsg = video.ToKeep ? "Off" : "On"
    let expireMsg = retentionExpired(video) ? "\n\nThe retention already expired for this case, so if \"Keep\" is switched Off, it can't be swtiched back On!" : "" 

    if (window.confirm(`Are you sure you want to switch ${statusMsg} Retention "Keep" status of the case, ${video.CaseNumber}?` + expireMsg)){
      const encodedId = toUrlSafeBase64(video.CaseNumber)
      api.post(`/api/retention/case/${encodedId}`, {CaseNumber: video.CaseNumber})
      .then(({data}) => {
        refresh()
      })
      .catch(error => { 
        alert("Failed to change case's retention status")
        console.error("Error: ", error) } )      
    }
  }

  const shouldDisable = (item) =>{
    if (retentionExpired(item) && !item.ToKeep) return true
    return false
  }

  const daysToRetention = (item) =>{
    if (!retentionDays || item.RetentionPassed) return NaN
    // Parse CreatedAt in Eastern Time Zone (assuming it's in UTC or ISO string)
    const itemMoment = moment.tz(item.CreatedAt, "America/New_York")
    // Compute the expiration date
    const expirationDate = itemMoment.clone().add(retentionDays, 'days')
    // Current date in Eastern Time
    const currentMoment = moment.tz("America/New_York")
    // Difference in days (expiration - current)
    const diffDays = expirationDate.diff(currentMoment, 'days')
    return diffDays + 1
//    return diffDays >= 0 ? diffDays : 0 // return 0 if already expired

  }

  const daysLeft = daysToRetention(item)
  // console.log('case, days: ', item.CaseNumber, daysLeft)

  const retentionExpired =(v)=>{
    return (v.RetentionPassed) || (!isNaN(daysLeft) && daysLeft <0)
  }

  const iconColor = (item) =>{
    if (item.ToKeep) return "green"
    if (retentionExpired(item)) return "red"
    // let days = daysToRetention(item)
    if (!isNaN(daysLeft)){
      if (daysLeft <= 15) return "red"
      if (daysLeft <= 30 ) return "orange"
    } 
    return "black"
  }

  const retentionIcon = (item) =>{
    if (item.ToKeep) return faCalendarCheck
    if (retentionExpired(item)) return faCalendarXmark
    return faCalendar
  }

  const setCreateDateWithZone = (date) =>{
    // console.log("CurrentTimeZoneName(auth): ", CurrentTimeZoneName(auth))
    setCreateTZTime(moment(date).tz(CurrentTimeZoneName(auth)).format(CurrentTimeFormat))
  }
  
  const providerFullName = GetUserFullname(video.ProviderID, users)
  const team = video.TeamID && teams && teams.find((item) => item.ID === video.TeamID)

  // console.log("Reports:", reports)
  const getReportStatus = (cn) =>{
    // console.log("CN: ", cn)
    let frs = reports?.filter(r=>r.CaseNumber === cn && r.Attempt === 0)
    if (frs?.length > 0){
      return  frs[0].Status
    }

    return ""
  }

  // Columns: Case #, video time, upload time, file name, device/tag, provider, team, action
  const getFlagColor = (cn) =>{
    let rStatus = getReportStatus(cn)
    switch (rStatus){
      case ReportStatus.Done:
        return "green"
      case ReportStatus.InProgress:
        return "orange"
    }
    return "red"
  } 

  const getBGString =(days)=>{
    return days<=30 && days>15 ? "bg-warning" : (days>=0 && days<=15 ? "bg-danger" : "bg-info")
  }

  if (video)
  return (
    <>
    <tr>
    {auth.IsRoot && <td>
        <input
          type="checkbox"
          checked={checked}
          onChange={() => handleRowCheckboxChange(video.CaseNumber)}
        />
      </td>}
      <td id="case-number-with-flag">
        <FontAwesomeIcon icon={faFlag} size="xs" color={getFlagColor(video.CaseNumber)}/>&nbsp;&nbsp;
        <Link to={`/case/${toUrlSafeBase64(video.CaseNumber)}`}>{video.CaseNumber}</Link>
      </td>
      <td>
        {TimeStringForTimeZone(auth, video.CreateDate)}
      </td>
      <td>{TimeStringForTimeZone(auth, video.CreatedAt)}</td>
      <td>
        {GetDeviceSNWithTag(video.Source, devices)}
      </td>
      <td>
        {providerFullName !== "" ? <span>{providerFullName}</span> : null}
      </td>
      {video.CaseNumber && auth?.IsRoot &&
      <td><ExportCaseReportButton caseNum={video.CaseNumber} 
            class="btn btn-outline-secondary btn-sm py-0 px-1" 
            style={{ padding: '0 4px', textAlign: 'center' }}/></td>}
      {video.CaseNumber && auth?.IsRoot &&
      <td>
        <div class="btn-group" role="group">
            <button class="btn btn-outline-secondary btn-sm py-0 px-1" style={{ padding: '0 4px', textAlign: 'center' }}
              onClick={()=>setShowNotifyModal(true)}>
              <FontAwesomeIcon icon={faEnvelope} />
            </button>
        </div>
      </td>}
      {enforceRetention && auth?.IsRoot && 
      <td>
        {shouldDisable(video) 
        ? <FontAwesomeIcon icon={retentionIcon(video)} color={iconColor(video)}/>
        : <button class="btn btn-outline-secondary btn-sm py-0 px-1" style={{ padding: '0 4px', textAlign: 'center' }} 
            id="retention_switch" onClick={()=>switchRetention()}>
            <FontAwesomeIcon icon={retentionIcon(video)} color={iconColor(video)}/> 
            {!video.ToKeep && !isNaN(daysLeft) && daysLeft>=0 && daysLeft<=30 && 
            <span /*class={"badge rounded-pill "+getBGString(daysLeft)} */ style={{textIndent: '0px'}}>{daysLeft}</span>}
          </button>}
      </td>}

    </tr>
    {labels?.length > 0 && <tr>
      {auth?.IsRoot && <td></td>}
      <td colspan={numColumns-1}><FontAwesomeIcon icon={faNoteSticky} size="xs" />&nbsp;&nbsp;{labels.join(", ")}</td>
    </tr>}
    { users && <UserNotifyModal show={showNotifyModal} setShow={setShowNotifyModal} caseNum={item.CaseNumber} />}
    {/* <ReactJson src={{deviceTag, video, device}} /> */}
    <Tooltip anchorSelect="#retention_switch" place="top" arrowColor="#222222">Switch "Keep" status</Tooltip>
    </>
  )
}

export const SearchableCaseLabeler = ({labels, casenum, readOnly, setCaseLabels}) => {
  const api = useDeepVinApi()

  const options = labels?.map(label => ({ value: label.Name, label: label.Name })) || []
  const [selLabels, setSelLabels] = useState([])
  const [searchInput, setSearchInput] = useState('')

  useEffect(() => {
    const encodedId = toUrlSafeBase64(casenum)
    api.get(`/api/case/${encodedId}/label`)
    .then(({data}) => {
      // console.log("case labels data: ", data)
      setSelLabels(data.Labels?.map(label => ({ value: label, label: label })))
    })
    .catch(error => {
        console.error("Error: ", error)
  })}, [casenum])

  // console.log("selected labels: ", selLabels)
  const handleSelect = (selected, action) => {
    // console.log("selected labels: ", selected)
    setSearchInput("")
    setSelLabels(selected)
    setCaseLabels(selected?.map(s=>s.label))
  }

  if (labels?.length > 0) {
    return (readOnly) ? (selLabels?.length > 0 ? 
                        (<span><FontAwesomeIcon icon={faNoteSticky} size="xs" />&nbsp;&nbsp;{selLabels.map(label => label.label).join(", ")}</span>) : 
                        (<span>(No Labels)</span>)) : 
      (
      <Select className={"basic-multi-select"}
        classNamePrefix="select"
        value={selLabels}
        onChange={handleSelect}
        options={options}
        // placeholder="Case labels"
        isMulti
        isSearchable={!readOnly}
        isDisabled={readOnly}
        //closeMenuOnSelect={false}
        //hideSelectedOptions={false}
        components={{ 
          Input: customSearchInput,
          // MultiValueRemove, // use custom version
          // DropdownIndicator,
          // IndicatorSeparator,
          }}
          
          // keep the menu above everything
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          menuPosition="fixed"          // avoids being affected by parent transforms/overflow
          menuPlacement="auto"          // optional: smarter positioning

        inputValue={searchInput}
        onInputChange={(value, action) => {
          if (action.action === 'input-change') {
            setSearchInput(value);
          }
        }}
        styles={{
          valueContainer: (provided) => ({
            ...provided,
            display: 'inline-flex',
          }),
          input: (provided) => ({
            ...provided,
            display: 'inline-flex', // Change from grid to flex
            border: '1px solid blue',
          }),
        }}
        readOnly={readOnly} // pass down to custom components
        />
      ) 
    } else {
      return <span>(No Labels)</span>
    }
}